import { render, staticRenderFns } from "./CodCustomerSearch.vue?vue&type=template&id=fe991a42&scoped=true"
import script from "./CodCustomerSearch.vue?vue&type=script&lang=js"
export * from "./CodCustomerSearch.vue?vue&type=script&lang=js"
import style0 from "./CodCustomerSearch.vue?vue&type=style&index=0&id=fe991a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe991a42",
  null
  
)

export default component.exports